export const UPDATE_FILTER = 'UPDATE_FILTER';
